import React from 'react';
import { InputBase, InputGroup } from '@milanote/roma';

type Props = {
    value: string;
    onChange: (value: string) => void;
};

const TagsSearchBar = ({ value, onChange }: Props) => {
    return (
        <div className="TagsSearchBar mb-3">
            <InputGroup size="sm" onChange={onChange} aria-label="Enter tag name">
                <InputBase type="text" placeholder="Enter tag name..." value={value} />
            </InputGroup>
        </div>
    );
};

export default TagsSearchBar;
